export const preferAdjustmentConciliationRows = (rows = []) => {
  const unique = new Map()
  const isAdjustment = row => [row?.tabla, row?.tablaPrincipal, row?.origenTabla, row?.libroContableOriginTableId]
    .some(table => [44, 45].includes(Number(table)))
  for (const row of rows) {
    const id = row?.idPrincipal ?? row?.id_principal ?? row?.id ?? row?.customId
    const key = id == null ? row : String(id)
    const previous = unique.get(key)
    if (!unique.has(key) || (!isAdjustment(previous) && isAdjustment(row))) unique.set(key, row)
  }
  return [...unique.values()]
}

// La cuota identifica la aplicación; idPrincipal sigue identificando el movimiento
// para las operaciones de selección y desconciliación.
export const getConciliationRenderKey = row => {
  const id = row?.idPrincipal ?? row?.id_principal ?? row?.id ?? row?.customId
  const cuota = row?.idCuota ?? row?.idcuota
  return cuota != null
    ? `cuota-${row?.tabla ?? row?.libroContableOriginTableId ?? ''}-${id}-${cuota}`
    : `movimiento-${row?._origen ?? row?.tipo ?? ''}-${id}`
}

export const mergeConciliationRows = (linked = [], selected = []) => {
  const movementId = row => String(row?.idPrincipal ?? row?.id_principal ?? row?.id)
  const linkedIds = new Set(linked.map(movementId))
  const result = new Map()
  // Conservar todas las aplicaciones y sus montos del response. La lista bancaria
  // contiene una sola fila por movimiento, aunque tenga varias aplicaciones.
  const persisted = linked.map(row => {
    const selection = selected.find(candidate => movementId(candidate) === movementId(row))
    const edited = selected.find(candidate => candidate.customRow === true && movementId(candidate) === movementId(row))
    const preferred = selection ? preferAdjustmentConciliationRows([row, selection])[0] : row
    const persistedRow = edited ? { ...preferred, ...edited } : preferred
    // Keep the selection's source so deselection reaches the correct unlink group,
    // without replacing the persisted amounts or individual installment data.
    return selection?._origen ? { ...persistedRow, _origen: selection._origen } : persistedRow
  })
  for (const row of [...persisted, ...selected.filter(row => !linkedIds.has(movementId(row)))]) {
    result.set(getConciliationRenderKey(row), row)
  }
  return preferAdjustmentConciliationRows([...result.values()])
}
